import { render, staticRenderFns } from "./AdminCouponsView.vue?vue&type=template&id=d41a7960"
import script from "./AdminCouponsView.vue?vue&type=script&lang=ts"
export * from "./AdminCouponsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports